<template>
    <component :is="layout"></component>
</template>
<script>
import MainLayout from "./components/commons/RomaLayoutMain";
import GeneralLayout from "./components/layouts/GeneralLayout";

import { mapGetters, mapActions } from "vuex";
export default {
    components: { MainLayout, GeneralLayout },
    created() {
        this.actionGetUser();
    },
    computed: {
        ...mapGetters({
            layout: "getLayout",
            getUserData: "getUserData"
        })
    },
    methods: {
        ...mapActions({
            actionGetUser: "actionGetUser"
        })
    }
};
</script>
<style lang="scss"></style>
